import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import AppShell from "./AppShell";
import { LangUpdateContext } from "./LangContext";

import { call } from "../util/action";
import { update_me } from "../util/redux/actions";
import { getStore } from "../util/redux/store";

/**
 * Wraps every signed-in route. The visible frame — sidebar, app bar, content — lives in
 * AppShell; this component only owns the cross-cutting concerns (language-refresh context and
 * keeping `me.county` hydrated).
 */
export const Layout = props => {
  const updateLangFn = () => {
    setLang(prevState => ({ ...prevState, updateLang: !prevState.updateLang }));
  };
  const [lang, setLang] = useState({ updateLang: false, updateLangFn });

  /* Subscribed, not read once from the store: the app bar's language switcher and the profile
     page both write `me`, and the shell has to re-render when they do. */
  const language = useSelector(state => state.me?.language);

  // Keep the logged-in user's default region (me.county) fresh and as a FULL object, regardless
  // of when they last logged in or whether a profile save reduced it to a bare id. Region
  // filters read me.county to pre-select and label the region without their own backend call.
  useEffect(() => {
    const meState = getStore().getState().me;
    if (!meState || !meState.id) return;
    call({ method: "GET", url: "users/" + meState.id + "/" }, r => {
      if (r && r.id && "county" in r) {
        const cur = getStore().getState().me;
        getStore().dispatch(update_me({ ...cur, county: r.county }));
      }
    });
  }, []);

  return (
    <LangUpdateContext.Provider value={lang}>
      <AppShell lang={language}>{props.children}</AppShell>
    </LangUpdateContext.Provider>
  );
};
